import { Fab, Tooltip } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useLocale } from "../providers/LocaleProvider";

interface KitFloatingButtonProps {
  onClick: () => void;
}

export function KitFloatingButton({ onClick }: KitFloatingButtonProps) {
  const { translate } = useLocale();

  return (
    <Tooltip title={translate("kit.subtitle")} placement='left'>
      <Fab
        size='medium'
        aria-label={translate("kit.title")}
        onClick={onClick}
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 1200,
          background:
            "linear-gradient(135deg, var(--neon-blue-nb-400, #4d5ef7) 0%, var(--neon-blue-nb-600, #1634e6) 100%)",
          color: "#fff",
          boxShadow: "0 4px 14px rgba(77, 94, 247, 0.4)",
          "&:hover": {
            background:
              "linear-gradient(135deg, var(--neon-blue-nb-500, #1b3df2) 0%, var(--neon-blue-nb-700, #0027da) 100%)",
            boxShadow: "0 6px 20px rgba(77, 94, 247, 0.5)"
          }
        }}
      >
        <AutoAwesomeIcon sx={{ fontSize: 20 }} />
      </Fab>
    </Tooltip>
  );
}
